import {PersonEntity,} from "@ots-frontend/ots-data";
import {useCallback} from "react";
import {useNavigate} from "react-router-dom";
import {PersonAction} from "./PersonActionMenu";
import {usePersonMutation} from "../../../hooks/usePersonMutation";

export type UsePersonActionProps = {}

export type UsePersonActionResult = {
  onPersonActionClick: (person: PersonEntity, action: PersonAction) => void;
}

export const usePersonAction = (props: UsePersonActionProps = {}): UsePersonActionResult => {
  const {} = props

  const navigate = useNavigate();

  const {
    deletePerson,
  } = usePersonMutation()

  const _onPersonActionClick = useCallback((person: PersonEntity, action: PersonAction) => {
    if (action === "EDIT") {
      navigate(`/persons/form`, {state: {id: person.id, database: person.database}})
    } else if (action === "DELETE") {
      deletePerson(person.id, undefined)
    }
  }, [navigate, deletePerson])

  return {
    onPersonActionClick: _onPersonActionClick
  }
}
